import React, { useMemo } from "react";
import classNames from "classnames";
import { ReactComponent as ChevronArrowSVG } from "@/assets/svgs/icons/chevron_arrow.svg";


interface ChevronArrowIconProps {
    className?: string;
    direction?: "up" | "down" | "left" | "right";
}

const ChevronArrowIcon: React.FC<ChevronArrowIconProps> = (props) => {
    const {
        className: propsClassName = "stroke-white size-4.5",
        direction = "down"
    } = props;

    const directionClassname = useMemo(() => {
        switch (direction) {
            case "up":
                return "rotate-180";
            case "down":
                return "rotate-0";
            case "left":
                return "rotate-90";
            case "right":
                return "-rotate-90";
        }
    }, [direction]);

    return (
        <ChevronArrowSVG className={classNames(propsClassName, directionClassname)} />
    );
};

export default ChevronArrowIcon;
